
import React, { Component } from "react";
import {
    GetGHGEstimationUrl
} from "../../config";


class AiFileUploadDataRemoval extends Component {
    constructor(props) {
        super(props);
        this.state = {
            jwtToken: "",
            organizationId: "",
        };
    }

    componentDidMount() { }

    render() {
        debugger
        const { classes } = this.props;
        const src = GetGHGEstimationUrl() + "admin/ai-file-removal/listing?accessToken=" + localStorage.opsToken;
        ///listing?accessToken=" + localStorage.opsToken;
        return (
            <iframe title="AI File Upload Data Removal"
                id="AI File Upload Data Removal"
                src={src}
                style={{ width: "100%", height: "100vh", border: "none" }}
            />
        )
    }
};

export default AiFileUploadDataRemoval;
